import _ from 'underscore';

import { DEFAULT_CHILDREN_ANSWERS_LIMIT } from 'bundles/groups-dashboard-content/constants/DiscussionGradingConstants';

class DiscussionAnswer {
  declare childAnswerCount: number;

  declare content: any;

  declare createdAt: number;

  declare creatorId: number;

  declare id: string;

  declare order: number;

  declare upvoteCount: number;

  declare parentCourseItemForumAnswerId: string;

  declare commentsList: Array<any>;

  constructor(data: any) {
    // TODO: Explicitly assign property values to be type safe.
    Object.assign(
      this,
      _(data).pick(
        'childAnswerCount',
        'content',
        'createdAt',
        'creatorId',
        'id',
        'order',
        'upvoteCount',
        'parentCourseItemForumAnswerId',
        'state'
      ),
      {
        commentsList: [],
      }
    );
  }

  get hasComments(): boolean {
    return this.childAnswerCount > 0;
  }

  get currentCommentPage(): number {
    return Math.floor((this.childAnswerCount - 1) / DEFAULT_CHILDREN_ANSWERS_LIMIT) + 1;
  }

  get courseItemForumAnswerId(): string {
    return _(this.id.split('~')).rest().join('~');
  }

  addComment(comment: any): any {
    this.commentsList.unshift(comment);
  }
}

export default DiscussionAnswer;
